export const CSRF_HEADER_NAME = 'X-TNS-CSRF';
export const CSRF_HEADER_VALUE = '1';

const UNSAFE_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

export const applySessionRequestPolicy = (config = {}) => {
  const method = String(config.method || 'get').toUpperCase();
  config.withCredentials = true;

  if (UNSAFE_METHODS.has(method)) {
    if (config.headers?.set) {
      config.headers.set(CSRF_HEADER_NAME, CSRF_HEADER_VALUE);
    } else {
      config.headers = {
        ...(config.headers || {}),
        [CSRF_HEADER_NAME]: CSRF_HEADER_VALUE,
      };
    }
  }

  return config;
};
